import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import type { DisparoCleanupOptions } from "@/lib/disparos-types";

interface DisparoCleanupDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (options: DisparoCleanupOptions) => void;
  loading?: boolean;
}

export function DisparoCleanupDialog({
  open,
  onOpenChange,
  onConfirm,
  loading,
}: DisparoCleanupDialogProps) {
  const [deleteSent, setDeleteSent] = useState(false);
  const [deleteFailed, setDeleteFailed] = useState(true);
  const [deletePending, setDeletePending] = useState(false);
  const [olderThanDays, setOlderThanDays] = useState(30);

  const handleConfirm = () => {
    onConfirm({
      delete_sent: deleteSent,
      delete_failed: deleteFailed,
      delete_pending: deletePending,
      older_than_days: olderThanDays > 0 ? olderThanDays : undefined,
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Limpeza de disparos</DialogTitle>
          <DialogDescription>
            Remove mensagens e campanhas antigas conforme os critérios abaixo.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <label className="flex items-center gap-2 text-sm">
            <Checkbox checked={deleteSent} onCheckedChange={(v) => setDeleteSent(v === true)} />
            Excluir mensagens enviadas
          </label>
          <label className="flex items-center gap-2 text-sm">
            <Checkbox checked={deleteFailed} onCheckedChange={(v) => setDeleteFailed(v === true)} />
            Excluir mensagens com falha
          </label>
          <label className="flex items-center gap-2 text-sm">
            <Checkbox
              checked={deletePending}
              onCheckedChange={(v) => setDeletePending(v === true)}
            />
            Excluir mensagens pendentes
          </label>
          <div className="space-y-1.5">
            <Label htmlFor="older-days">Mais antigas que (dias)</Label>
            <Input
              id="older-days"
              type="number"
              min={1}
              value={olderThanDays}
              onChange={(e) => setOlderThanDays(Number(e.target.value) || 0)}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button onClick={handleConfirm} disabled={loading}>
            Executar limpeza
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
